import { findFilterGroup, isFilterGroupAvailable } from './getFiltersGroups';
import { SERP_QUICK_FILTERS } from '../config/filters';
import { SERP_QUICK_FILTERS_TEXTS } from '../config/texts';
import type { SelectedFilter, SerpFilterViewContext, SerpQuickFilterView } from '../model/types';

export function formatQuickFilterLabel(title: string, selectedFilters: readonly SelectedFilter[]): string {
  if (selectedFilters.length === 1) return selectedFilters[0].label;
  if (selectedFilters.length > 1) return `${title}${SERP_QUICK_FILTERS_TEXTS.countSeparator}${selectedFilters.length}`;

  return title;
}

export function getQuickFilters(
  context: SerpFilterViewContext,
  selectedFilters: readonly SelectedFilter[],
): SerpQuickFilterView[] {
  const quickFilters: SerpQuickFilterView[] = [];

  for (const quickFilter of SERP_QUICK_FILTERS) {
    const group = findFilterGroup(quickFilter.id);

    if (!group) continue;

    const groupSelectedFilters = selectedFilters.filter((selectedFilter) => selectedFilter.groupId === group.id);
    const available = isFilterGroupAvailable(context, group);

    if (!available && !groupSelectedFilters.length) continue;

    const title = quickFilter.title ?? group.title;

    quickFilters.push({
      id: group.id,
      control: group.control,
      label: group.control === 'checkbox' ? title : formatQuickFilterLabel(title, groupSelectedFilters),
      selected: groupSelectedFilters.length > 0,
      available,
    });
  }

  return quickFilters;
}
